"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlGetter = void 0;
var csod = require("player-core");
var UrlHelper_1 = require("./UrlHelper");
var UrlGetter = (function () {
    function UrlGetter() {
    }
    UrlGetter.createJobDetailsUrl = function (isCareerSiteResponsive, reqId, careerSiteId, isCareerCenter, queryStringParameters, cultureName) {
        if (isCareerCenter === void 0) { isCareerCenter = false; }
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        if (cultureName === void 0) { cultureName = ''; }
        var jobDetailsUrl = '';
        if (isCareerCenter) {
            var queryString = '';
            if (!(Object.keys(queryStringParameters).length === 0 && queryStringParameters.constructor === Object)) {
                queryString = "?" + UrlHelper_1.UrlHelper.buildQueryString(queryStringParameters);
            }
            jobDetailsUrl = csod.context.applicationBase + "ui/internal-career-site/app/job-details/" + reqId + queryString;
        }
        else {
            if (isCareerSiteResponsive === true) {
                var lang = '';
                if (cultureName) {
                    lang = "&lang=" + cultureName;
                }
                var serviceUrl = csod.context.applicationBase + "ux/ats/careersite/" + careerSiteId + "/home?c=" + csod.context.corp + lang + "#/requisition/" + reqId;
                jobDetailsUrl = (queryStringParameters && queryStringParameters.source)
                    ? serviceUrl + "&source=" + queryStringParameters.source
                    : "" + serviceUrl;
            }
            else {
                var serviceUrl = csod.context.applicationBase + "ATS/CareerSite/JobDetails.aspx?id=" + reqId + "&site=" + careerSiteId + "&c=" + csod.context.corp;
                jobDetailsUrl = (queryStringParameters && queryStringParameters.source)
                    ? serviceUrl + "&source=" + queryStringParameters.source
                    : "" + serviceUrl;
            }
        }
        return jobDetailsUrl;
    };
    UrlGetter.createBackToSearchUrl = function (isCareerSiteResponsive, reqId, careerSiteId, isCareerCenter, queryStringParameters, cultureName) {
        if (isCareerCenter === void 0) { isCareerCenter = false; }
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        if (cultureName === void 0) { cultureName = ''; }
        var backToSearchUrl = '';
        if (isCareerCenter) {
            var queryString = '';
            if (!(Object.keys(queryStringParameters).length === 0 && queryStringParameters.constructor === Object)) {
                queryString = "?" + UrlHelper_1.UrlHelper.buildQueryString(queryStringParameters);
            }
            backToSearchUrl = csod.context.applicationBase + "ui/internal-career-site/app/search-jobs" + queryString;
        }
        else {
            if (isCareerSiteResponsive === true) {
                var lang = '';
                if (cultureName) {
                    lang = "&lang=" + cultureName;
                }
                backToSearchUrl = csod.context.applicationBase + "ux/ats/careersite/" + careerSiteId + "/home?c=" + csod.context.corp + lang + "#/";
            }
            else {
                backToSearchUrl = csod.context.applicationBase + "ats/careersite/search.aspx?site=" + careerSiteId + "&c=" + csod.context.corp;
            }
        }
        return backToSearchUrl;
    };
    return UrlGetter;
}());
exports.UrlGetter = UrlGetter;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/shared/code/UrlGetter.ts
// module id = 168
// module chunks = 0 2